import { mapGetters } from "vuex";
import { formatDate } from "@/utils/date-helper";
import { formatMoney, formatPercent } from "@/utils/number-utils";

import ApiBase from "@/utils/api-base";

export default {
  components: {
    ReportBase: () => import("./ReportBase"),
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["getDateRange", "getVendor"]),

    startDate() {
      let start_date = this.getDateRange.start;

      start_date = new Date(
        Date.UTC(
          start_date.getFullYear(),
          start_date.getMonth(),
          start_date.getDate()
        )
      );
      start_date.setUTCHours(0, 0, 0);

      return start_date.toISOString();
    },

    endDate() {
      let end_date = new Date(this.getDateRange.end);

      end_date = new Date(
        Date.UTC(
          end_date.getFullYear(),
          end_date.getMonth(),
          end_date.getDate()
        )
      );
      end_date.setUTCHours(23, 59, 59);

      return end_date.toISOString();
    },

    localCurrency() {
      return this.getVendor.local_currency;
    },
  },

  methods: {
    formatDate(date, format = "MMMM DD, YYYY") {
      return formatDate(date, format);
    },

    formatMoney(value, decimals = 2, show_empty = false, show_prefix = true) {
      if (!value && !show_empty) {
        return "";
      }

      return show_prefix
        ? formatMoney(value, decimals, this.localCurrency)
        : formatMoney(value, decimals, "");
    },

    formatPercent(value, decimals = 2, show_empty = false) {
      if (!value && !show_empty) {
        return "";
      }

      return formatPercent(value, decimals);
    },

    fetchData(subject) {
      const params = {
        starts_at: this.startDate,
        ends_at: this.endDate,
      };

      return ApiBase.get(`/analytics/${subject}`, params);
    },

    fetchDataByParams(subject, params) {
      return ApiBase.get(`/analytics/${subject}`, params);
    },

    today() {
      return new Date();
    },
  },
};
